export default "__VITE_ASSET__CAjTIV8x__"